var _circle, _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlueTickWithBlueBorderIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    stroke: "#3876BB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.075 7.49167L8.65833 13.9083C8.54167 14.025 8.425 14.0833 8.25 14.0833C8.075 14.0833 7.95833 14.025 7.84167 13.9083L4.925 10.9917C4.69167 10.7583 4.69167 10.4083 4.925 10.175C5.15833 9.94167 5.50833 9.94167 5.74167 10.175L8.25 12.6833L14.2583 6.675C14.4917 6.44167 14.8417 6.44167 15.075 6.675C15.3083 6.90833 15.3083 7.25833 15.075 7.49167Z",
    fill: "#828282"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_25678_13470",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 6,
    width: 12,
    height: 9
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.075 7.49167L8.65833 13.9083C8.54167 14.025 8.425 14.0833 8.25 14.0833C8.075 14.0833 7.95833 14.025 7.84167 13.9083L4.925 10.9917C4.69167 10.7583 4.69167 10.4083 4.925 10.175C5.15833 9.94167 5.50833 9.94167 5.74167 10.175L8.25 12.6833L14.2583 6.675C14.4917 6.44167 14.8417 6.44167 15.075 6.675C15.3083 6.90833 15.3083 7.25833 15.075 7.49167Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_25678_13470)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 3H17V17H3V3Z",
    fill: "#3876BB"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueTickWithBlueBorderIcon);
export default __webpack_public_path__ + "static/media/BlueTickWithBlueBorderIcon.182bba9bc79202d5a46c5374403f1e46.svg";
export { ForwardRef as ReactComponent };